module.exports = __webpack_public_path__ + "img/cane.605dbaff.svg";